import { Component } from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';

@Component({
  selector: 'evrideo-user-branding',
  templateUrl: './user-branding.component.html',
  styleUrl: './user-branding.component.scss'
})
export class UserBrandingComponent {

}
